export default __webpack_public_path__ + "static/media/avatar3.9219b7e4.png";